import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikDaekning } from '../../models/StatistikDaekning';
import { StatistikDaekningFakturaModal } from '../statistik-daekning-faktura-modal/statistik-daekning-faktura-modal';
import { StatistikDaekningSagModal } from '../statistik-daekning-sag-modal/statistik-daekning-sag-modal';
import { StatistikDaekningKunde } from '../../models/StatistikDaekningKunde';
import { StatistikService } from '../../statistik.service';
import { combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-statistik-igangvaerende-daekning-kunde-modal-ui',
    templateUrl: './statistik-daekning-kunde-modal.html',
    styleUrls: ['./statistik-daekning-kunde-modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikDaekningKundeModal {
    @Input() kunde: StatistikDaekning;
    @Input() periode: {fra: string, til: string};
    @Input() sager: StatistikDaekningKunde[];

    constructor(
        private activeModal: NgbActiveModal,
        private statistikService: StatistikService,
        private modalService: NgbModal
    ) { }

    onDismiss() {
        this.activeModal.dismiss();
    }

    OpenBrugtModal(sag: StatistikDaekningKunde) {
        combineLatest([
            this.statistikService.getDaekningKundeBrugtTimer(this.periode, this.kunde.kid, sag.sagsID),
            this.statistikService.getDaekningKundeBrugtKr(this.periode, this.kunde.kid, sag.sagsID)
        ]).pipe(
            tap(([timer, kr]) => {
                const sagModal = this.modalService.open(StatistikDaekningSagModal, {size: 'lg'});
                sagModal.componentInstance.brugtTimer = timer;
                sagModal.componentInstance.brugtKr = kr;
            })
        ).subscribe();
    }

    OpenFakturaModal(sag: StatistikDaekningKunde) {
        this.statistikService.getDaekningKundeFaktureret(this.periode, this.kunde.kid, sag.sagsID).pipe(
            tap(faktura => {
                const sagModal = this.modalService.open(StatistikDaekningFakturaModal, {size: 'lg'});
                sagModal.componentInstance.faktura = faktura;
            })
        ).subscribe();
    }

    brugtTotal() {
        let total = 0;
        this.sager.forEach(sag => {
            total += sag.brugt;
        });
        return Math.round(total);
    }

    faktureretTotal() {
        let total = 0;
        this.sager.forEach(sag => {
            total += sag.faktureret;
        });
        return Math.round(total);
    }
}
